var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSound = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 38,
    viewBox: "0 0 86 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 16.8125C24.0831 17.9237 24.0831 20.0762 23.25 21.1875",
    stroke: "white",
    strokeWidth: 1.24999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.125 14.625C27.6175 17.005 27.6325 21.0106 25.125 23.3749",
    stroke: "white",
    strokeWidth: 1.24999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.8493V17.15C14.5 16.7912 14.78 16.5 15.125 16.5H17.3662C17.4489 16.4997 17.5307 16.4827 17.6067 16.4499C17.6826 16.4171 17.7511 16.3693 17.8081 16.3094L19.6831 14.1919C20.0768 13.7819 20.7499 14.0725 20.7499 14.6519V23.3481C20.7499 23.9318 20.0687 24.2199 19.6775 23.8018L17.8087 21.6962C17.7516 21.6345 17.6824 21.5853 17.6054 21.5515C17.5284 21.5178 17.4453 21.5002 17.3612 21.4999H15.125C14.78 21.4999 14.5 21.2087 14.5 20.8493Z",
    stroke: "white",
    strokeWidth: 1.24999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 11,
    width: 2,
    height: 17,
    rx: 1,
    fill: "#8B8B8B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 19,
    width: 2,
    height: 9,
    rx: 1,
    fill: "#8B8B8B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 14,
    width: 2,
    height: 14,
    rx: 1,
    fill: "#8B8B8B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 23,
    width: 2,
    height: 5,
    rx: 1,
    fill: "#8B8B8B"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 17,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#8B8B8B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 21,
    width: 2,
    height: 7,
    rx: 1,
    fill: "#8B8B8B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Sound.dbe801da.svg";
export { ForwardRef as ReactComponent };